import React, { useEffect, useState, ReactNode, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, isNumber, round } from 'lodash';
import { init } from 'echarts';

import Color from '@tool/color';
import { newRate } from '@tool/index';

interface IProps {
  height: number,
  yData: any[],
  xData: any[],
  name?: string | number,
}
interface IState { }

const IncomeRight = (props: IProps, state: IState) => {
  let chart: any = null;
  const navi = useNavigate();
  const { height, xData, yData, name } = props;
  const rightChartRef = useRef<any>(null);
  const colorList = [Color.primary, Color.two, Color.secondary];
  const render = () => {
    if (chart) chart.dispose();
    chart = init(rightChartRef.current);
    const option = {
      tooltip: {
        show: false,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: (parmes: any) => {
          let htl = `<p style="font-family: 'PingFang SC'">${name || parmes[0].seriesName}</p>`;
          parmes?.forEach((element: any, i: number) => {
            htl += `<p style="margin-top:10px;display:flex;
                      justify-content: flex-start;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;background:${colorList[element.seriesIndex]};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC'">${element.name}</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';padding-top:4px;flex:1;text-align:right">
                        ${isNumber(element.value) ? `${round(element.value * 100, 1)}%` : '-'}
                      </span>
                    </p>`;
          });
          return htl;
        },
      },
      legend: {
        show: false,
      },
      grid: {
        left: 40,
        right: 40,
        bottom: 0,
        top: 20,
        containLabel: true,
      },
      xAxis: {
        type: 'value',
        axisLine: {
          show: false,
          lineStyle: { color: Color.ccc },
        },
        axisTick: { show: false },
        axisLabel: {
          show: true,
          color: Color.white,
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: Color.blackColor(0.08),
            width: 1,
            type: 'dashed',
          },
        },
      },
      yAxis: {
        type: 'category',
        data: yData,
        axisTick: { show: false },
        axisLabel: {
          show: false,
        },
        axisLine: {
          lineStyle: { color: Color.ec },
        },
      },
      animation: false,
      series: [
        {
          name: '2011',
          type: 'bar',
          barWidth: 14,
          borderRadius: 2,
          label: {
            formatter(parmars: any) {
              return `${round(parmars.value * 100, 1)}%`;
            },
            show: true,
            fontFamily: 'Roboto',
            fontSize: '14px',
          },
          data: xData?.map((item: any) => {
            return {
              value: item,
              itemStyle: {
                color: item > 0 ?
                  {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [{
                      offset: 0, color: Color.errorColor(0.8), // 0% 处的颜色
                    }, {
                      offset: 1, color: Color.errorColor(0.9), // 100% 处的颜色
                    }],
                    global: false, // 缺省为 false
                  } :
                  {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 1,
                    y2: 0,
                    colorStops: [{
                      offset: 0, color: Color.successColor(0.5), // 0% 处的颜色
                    }, {
                      offset: 1, color: Color.successColor(0.9), // 100% 处的颜色
                    }],
                    global: false, // 缺省为 false
                  },
                borderRadius: item > 0 ? [0, 2, 2, 0] : [2, 0, 0, 2],
              },
              label: {
                show: true,
                position: item > 0 ? 'left' : 'right',
                fontSize: 12,
              },
            };
          }),
        },
      ],
    };
    chart.setOption(option, true);
  };

  useEffect(() => {
    render();
    window.addEventListener('resize', render);
    return () => {
      window.removeEventListener('resize', render);
    };
  }, [xData, yData]);


  return (
    <section className="ratio" ref={rightChartRef}
      style={{ width: '100%', height: `${height}px` }} />
  );
};

export default observer(IncomeRight);
